import { useCallback } from 'react';
import { message } from 'antd';

export const useCopyToClipBoard = () =>
  useCallback((content) => {
    navigator.clipboard.writeText(content).then(
      function () {
        message.success('Copied to clipboard');
      },
      function () {
        message.error("Can't copy text to the clipboard");
      },
    );
  }, []);
